type ChartTooltipProps = {
  formattedValue: string;
  color?: string;
};
export function ChartTooltip({ formattedValue, color }: ChartTooltipProps) {
  return (
    <div className="flex items-center px-3 py-2 rounded-sm shadow-md bg-neutral-700 gap-x-2">
      {color && <div className="w-3 h-3 rounded-xs shrink-0" style={{ backgroundColor: color }} />}
      <div className="text-xs text-left text-white ">{formattedValue}</div>
    </div>
  );
}
